<template>
  <div ref="whole_page" class="text-left">
    <div v-if="$route.name == 'Gen2PracticalTimeCapture'" id="lp-details-container" class="mb-3 mx-4">
      <div class="vx-row mt-n3">
        <div class="vx-col self-center w-full">
          <div class="vx-row">
            <div class="vx-col self-center w-1/5 center-v-h">
              <p class="gen2-large-numbers text-white">{{ selectedLP.number }}</p>
            </div>
            <div class="vx-col self-center w-3/5 text-left">
              
            </div>
            <div class="vx-col self-center w-1/5 center-v-h">
              <custom-svg variant="arrow" width="40" height="40" dir="down" color="white" />
            </div>
          </div>
        </div>
      </div>
      <div class="vx-row mt-n3">
        <div class="vx-col self-center w-full">
          <div class="vx-row">
            <div class="vx-col self-center w-1/6">
              <feather-icon icon="CodesandboxIcon" class="text-white" svg-classes="stroke-current h-10 w-10"></feather-icon>
            </div>
            <div class="vx-col self-center w-5/6 text-left self-center lp-name">
              <h4 class="w-full">
                <span>{{ selectedLP.name }}&nbsp;</span>
              </h4>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="showLoading" class="mx-4">
      <custom-skeleton :show="showLoading" size="large" :count="8" />
    </div>
    <div v-else class="vx-row mx-4">
      <div class="vx-col mx-auto" :class="$route.name == 'Gen2PracticalTimeCapture' ? 'w-full' : 'xs:w-full sm:w-full md:w-full lg:w-5/6 xl:w-3/4'">
        <div v-if="$route.name == 'SARSTimeCapture' && $route.query.moduleId" class="mb-3">
          <div class="flex">
            <div class="self-center">
              <feather-icon icon="CodesandboxIcon" class="text-white" svg-classes="stroke-current h-10 w-10"></feather-icon>
            </div>
            <div class="self-center lp-name ml-4">
              <h4 class="w-full">
                <span>{{ lpName }}</span>
              </h4>
            </div>
          </div>
        </div>
        <div v-if="$route.name == 'SARSTimeCapture' && !$route.query.moduleId" class="mb-3">
          <div class="flex">
            <div class="self-center">
              <feather-icon icon="CalendarIcon" class="text-white" svg-classes="stroke-current h-10 w-10"></feather-icon>
            </div>
            <div class="self-center lp-name ml-4">
              <h4 class="w-full">
                <span>Questions for time period: <strong>{{ startDate }}</strong> - <strong>{{ endDate }}</strong></span>
              </h4>
            </div>
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col w-full">
            <div v-for="(_question, index) in questions" :key="index">
              <div :class="{ 'gen2-time-capture-item mb-3': $route.name == 'Gen2PracticalTimeCapture' }">
                <h5 class="font-brightgreen">{{ index + 1 }}. {{ _question.questionText }}</h5>
                <div class="vx-row">
                  <div class="vx-col w-full">
                    <p>How many hours did you spend on this task? </p>
                    <p class="mb-2"><small>Selected time:&nbsp;<strong>{{ !_question.timeValue ? "None" : `${_question.timeValue} ${_question.timeValue == 1 ? 'hour' : 'hours'}` }}</strong></small></p>
                    <vue-slider
                      :class="{ 'gen2-slider': $route.name == 'Gen2PracticalTimeCapture', 'w-full mb-5': $route.name != 'Gen2PracticalTimeCapture' }"
                      :tooltip="'none'"
                      v-model="_question.timeValue"
                      :adsorb="true"
                      :min="0"
                      :max="10"
                      :data-label="'id'"
                      :data-value="'id'"
                      :marks="true"
                    ></vue-slider>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="questions.length > 0 && $route.name == 'Gen2PracticalTimeCapture'" class="vx-row my-3">
          <div class="vx-col w-full">
            <vs-button class="vs-con-loading__container w-full" style="border-radius: 30px;" ref="submitbtn" color="#20AA34" type="border" @click="submit">Submit Times</vs-button>
          </div>
        </div>
        <div v-else-if="questions.length > 0" class="vx-row mt-3">
          <vs-spacer />
          <div class="vx-col">
            <vs-button class="vs-con-loading__container" ref="submitbtn" color="success" type="filled" @click="submit">Submit Times</vs-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueSlider from 'vue-slider-component'
import 'vue-slider-component/theme/antd.css'
import CustomSvg from '@/gen-2/components/CustomSVG.vue';
import moment from 'moment'
export default {
  components: {
    VueSlider,
    CustomSvg,
    moment
  },
  data() {
    return {
      questions: [],
      selectedLP: {},
      showLoading: false,
      lpName: null,
      startDate: null,
      endDate: null
    };
  },
  computed: {},
  methods: {
    loadData() {
      var self = this;

      if (self.$getSiteId() == 35) {
        self.showLoading = true;
      } else {
        self.showLoadingOnElement("whole_page", 1, "material");
      }

      var onSuccess = function (response) {
        self.questions = response.data;
        if (document.getElementById("lp-details-container")) {
          document.getElementById("lp-details-container").scrollIntoView();
        }
      };
      var onFinally = function () {
        if (self.$getSiteId() == 35) {
          self.showLoading = false;
        } else {
          self.$vs.loading.close(self.$refs.whole_page.$el);
        }
      };

      self.$ajaxGet(self, `Module/GetModuleActivityLogsForCoke?moduleId=${self.$route.query.moduleId || self.selectedLP.moduleId}`, onSuccess, onFinally);
    },
    loadSarsQuestions() {
      var self = this;

      self.showLoadingOnElement("whole_page", 1, "material");

      var onSuccess = function (response) {
        self.lpName = response.data.moduleName;
        self.questions = response.data.questions;

        var startDate = new Date(Date.parse(response.data.startDate));
        var endDate = new Date(Date.parse(response.data.endDate));

        self.startDate = moment(startDate).format("dddd, DD MMMM");
        self.endDate = moment(endDate).format("dddd, DD MMMM");
      };
      var onFinally = function () {
        self.$vs.loading.close(self.$refs.whole_page.$el);
      };

      self.$ajaxGet(self, `SonkeSarsQuestion/GetQuestionsToAnswer?moduleId=${self.$route.query.moduleId}`, onSuccess, onFinally);
    }, 
    submit() {
      var self = this;

      self.showLoadingOnElement("submitbtn", 0.45, "material");

      var answers = [];
      
      var onSuccess = response => {
        if (self.$getSiteId() == 35) {
          self.$router.push({ name: "Gen2LearningPrograms", query: { ref: "continue" } });
        } else if (self.$getSiteId() == 26) {
          self.$router.back();
        } else if (self.$route.query.moduleId) {
          self.$router.push({ name: "LearningStyleBViewer", params: { moduleId: self.$route.query.moduleId }});
        } else {
          self.$router.back();
        }
      };
      var onFinally = response => {
        self.$vs.loading.close(self.$refs.submitbtn.$el);
      };

      if (self.$getSiteId() == 35) {
        self.questions.forEach(_question => {
          answers.push({
            id: _question.id,
            moduleId: self.selectedLP.moduleId,
            questionId: _question.questionId,
            timeValue: _question.timeValue
          });
        });

        self.$ajaxPost(self, "Module/LogActivity", answers, onSuccess, onFinally);
      } else if (self.$route.query.moduleId && self.$route.name != 'SARSTimeCapture') {
        self.questions.forEach(_question => {
          answers.push({
            id: _question.id,
            moduleId: self.$route.query.moduleId,
            questionId: _question.questionId,
            timeValue: _question.timeValue
          });
        });

        self.$ajaxPost(self, "Module/LogActivity", answers, onSuccess, onFinally);
      } else if (self.$getSiteId() == 26 && self.$route.name == 'SARSTimeCapture') {
        self.questions.forEach(_question => {
          answers.push({
            moduleId: self.$route.query.moduleId || null,
            questionId: _question.id,
            timeValue: _question.timeValue
          });
        });

        self.$ajaxPost(self, "SonkeSarsQuestion/SubmitTimes", answers, onSuccess, onFinally);
      } else {
        self.questions.forEach(_question => {
          answers.push({ questionId: _question.questionId, time: _question.timeValue });
        });

        self.$ajaxPost(self, "PracticalQuestion/SubmitTimes", answers, onSuccess, onFinally);
      }
    },
    showLoadingOnElement(element, scale, type) {
      var self = this;
      self.$vs.loading({
        type: type,
        container: self.$refs[element].$el,
        scale: scale,
      });
    },
    stopLoadingOnElement(element) {
      var self = this;
      self.$vs.loading.close(self.$refs[element].$el);
    },
  },
  mounted() {
    var self = this;
    self.selectedLP = localStorage.lpToContinueFrom ? JSON.parse(localStorage.lpToContinueFrom).lp : {};

    if (self.$route.name == 'SARSTimeCapture') {
      self.loadSarsQuestions();
    } else {
      self.loadData();
    }
  },
};
</script>

<style lang="scss">
</style>
